<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t("UPDATEWEEKEND")}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">
           <vs-table ref="table"   class="mr-5 ml-5" pagination :max-items="10"  :data="weekends">
      <template slot="thead">
        <vs-th sort-key="Day">{{$t("Day")}}</vs-th>
        <vs-th sort-key="Weekend">{{$t("IsWeekend")}}</vs-th>

      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Day }}</p>
              </vs-td>
               <vs-td>
                   <vs-checkbox color="success" v-model="tr.IsWeekEnd"></vs-checkbox>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button  class="mr-6" @click="submitData" >{{$t('Submit')}}</vs-button>
      <vs-button type="border" color="danger" class="mr-6" @click="isSidebarActiveLocal = false" >{{$t('Cancel')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },

  },



  data() {
    return {

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");

        }
      }
    },
   weekends: {
      get() {
        return this.$store.state.holidayList.weekdays;
      },

    },

  },

  methods: {
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {

           this.$store.dispatch("holidayList/UpdateWeekend", this.$store.state.holidayList.weekdays).catch(err => {
              console.error(err);
            });

          this.$emit("closeSidebar");
          this.initValues();

        }
      });
    },


  },
  created(){

  },

  components: {
    VuePerfectScrollbar,

  }
};
</script>

<style>
.vs-table--tbody-table
{
  min-width: 319px;
}
</style>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.spacer{
    clear: both;
    height: 10px;
}
</style>
